import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { TextField } from "@mui/material";
import { Filter, GlobalSearchSelectOption } from "data/@types/GlobalSearchData";
import { useAdvancedViewFiltersStore } from "data/store/global-search/AdvancedViewFiltersStore";
import AppIcon from "ui/components/icons/AppIcon";
import { iconExpandMore } from "ui/components/icons";

const SelectChevronIcon = () => (
  <AppIcon
    icon={iconExpandMore}
    fontSize="small"
    sx={{ mr: 1, pointerEvents: "none" }}
  />
);

export type FilterOperator =
  | "contains"
  | "contains_two_directions"
  | "does_not_contain"
  | "equals"
  | "does_not_equal"
  | "starts_with"
  | "ends_with"
  | "is_empty"
  | "is_not_empty"
  | "in";

type OperatorSelectProps = {
  filter: Filter;
  activityType: GlobalSearchSelectOption;
};

const OPERATORS = [
  { value: "contains", label: "Contains" },
  { value: "does_not_contain", label: "Does not contain" },
  { value: "equals", label: "Equals" },
  { value: "does_not_equal", label: "Does not equal" },
  { value: "starts_with", label: "Starts with" },
  { value: "ends_with", label: "Ends with" },
  { value: "is_empty", label: "Is empty" },
  { value: "is_not_empty", label: "Is not empty" },
] as const;

export const OperatorSelect = ({
  filter,
  activityType,
}: OperatorSelectProps) => {
  const activeFilters = useAdvancedViewFiltersStore(
    (state) => state.filtersByActivity[activityType] || {},
  );
  const setActiveFilters = useAdvancedViewFiltersStore(
    (state) => state.setFiltersForActivity,
  );

  const handleChange = (event: SelectChangeEvent) => {
    setActiveFilters(activityType, {
      ...activeFilters,
      [filter.label]: {
        ...activeFilters[filter.label],
        operator: event.target.value as FilterOperator,
      },
    });
  };

  return (
    <>
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <InputLabel id="operator-select-label">Operator</InputLabel>
          <Select
            sx={{
              my: 1,
            }}
            labelId="operator-select-label"
            size="small"
            id="operator-select"
            value={activeFilters[filter?.label]?.operator ?? "contains"}
            label="Operator"
            onChange={handleChange}
            IconComponent={SelectChevronIcon}
          >
            {OPERATORS.map(({ value, label: optionLabel }) => (
              <MenuItem key={value} value={value}>
                {optionLabel}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <TextField
        size="small"
        label={filter.label}
        fullWidth
        value={activeFilters[filter.label]?.valueText || ""}
        onChange={(e) => {
          setActiveFilters(activityType, {
            ...activeFilters,
            [filter.label]: {
              ...activeFilters[filter.label],
              operator: activeFilters[filter?.label]?.operator ?? "contains",
              valueText: e.target.value,
            },
          });
        }}
      />
    </>
  );
};
